import React, { Fragment, useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import { useHistory } from "react-router-dom";

import sessionContext from '../../context/session/sessionContext';

const Navbar = () => {
  let history = useHistory();

  const _sessionContext = useContext(sessionContext)

  const { activePage, setActivePage } = _sessionContext

  const [menuOpen, setMenuOpen] = useState(false)

  const goTo = (page, ruta) => {
    setActivePage(page)
    setMenuOpen(false)
    history.push(ruta)
  }

  return (
    <Fragment>
      <div id="brandDiv">
        <img
          src={process.env.PUBLIC_URL + '/gea.png'}
          onClick={() => goTo('inicio', '/inicio')}
          className="clickable"
          alt="GEA"
          height="100"
        />
        <button
          className={menuOpen ? "nav-burger open" : "nav-burger"}
          aria-label="Abrir menú de navegación"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      <nav id="navbar" className="navbar navbar-expand-lg navbar-light bg-light">
        <ul className={menuOpen ? "navbar-nav mr-auto ml-sm-5 open" : "navbar-nav mr-auto ml-sm-5"}>
          <li className={activePage === "inicio" ? "nav-item active" : "nav-item"}>
            <Link className="nav-link" onClick={() => { setActivePage("inicio"); setMenuOpen(false) }} to="/">Inicio</Link>
          </li>
          <li className={activePage === "pedanias" ? "nav-item active" : "nav-item"}>
            <Link className="nav-link" onClick={() => { setActivePage("pedanias"); setMenuOpen(false) }} to="/pedanias">Pedanias</Link>
          </li>
          <li className={activePage === "discrecionales" ? "nav-item active" : "nav-item"}>
            <Link className="nav-link" onClick={() => { setActivePage("discrecionales"); setMenuOpen(false) }} to="/discrecionales">Discrecionales</Link>
          </li>
          <li className={activePage === "contacto" ? "nav-item active" : "nav-item"}>
            <Link className="nav-link" onClick={() => { setActivePage("contacto"); setMenuOpen(false) }} to="/contacto">Contacto</Link>
          </li>
        </ul>
      </nav>
    </Fragment>
  )
}

export default Navbar
